import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 480,
    margin: '0 auto',
    padding: `${theme.spacing(8)}px ${theme.spacing(2)}px ${theme.spacing(4)}px`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: theme.typography.h5.fontSize,
    marginBottom: theme.spacing(2),
  },
  message: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body1.fontSize,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  unsubscribeButton: {
    marginTop: theme.spacing(2),
    minWidth: 180,
    alignSelf: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(4),
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > a': {
      color: theme.palette.text.primary,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  divider: {
    width: 2,
    backgroundColor: theme.palette.text.primary,
    minHeight: 14,
    margin: `-2px ${theme.spacing(1)}px 0`,
  },
  successIcon: {
    color: theme.palette.success.main,
    fontSize: 72,
    marginBottom: theme.spacing(1),
  },
  warningIcon: {
    color: theme.palette.warning.main,
    fontSize: 72,
    marginBottom: theme.spacing(1),
  },
}));
